import script from "./rec-number-field.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-number-field.vue?vue&type=script&lang=ts&setup=true"

import "./rec-number-field.vue?vue&type=style&index=0&id=d00a4058&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d00a4058"]])

export default __exports__